// Copyright 2018-2024 the Deno authors. All rights reserved. MIT license.
// This module is browser compatible.

import { assertPath } from "../_common/assert_path.ts";
import { isPosixPathSeparator } from "./_util.ts";

/**
 * Verifies whether provided path is absolute.
 *
 * @example Usage
 * ```ts
 * import { isAbsolute } from "@std/path/posix/is-absolute";
 * import { assert, assertFalse } from "@std/assert";
 *
 * assert(isAbsolute("/home/user/Documents/"));
 * assertFalse(isAbsolute("home/user/Documents/"));
 * ```
 *
 * @param path The path to verify.
 * @returns Whether the path is absolute.
 */
export function isAbsolute(path: string): boolean {
  assertPath(path);
  return path.length > 0 && isPosixPathSeparator(path.charCodeAt(0));
}

// denoCacheMetadata={"headers":{"x-jsr-cache-status":"hit","server":"UploadServer","x-goog-stored-content-length":"756","date":"Fri, 08 Nov 2024 09:21:07 GMT","cache-control":"public, max-age=31536000, immutable","last-modified":"Fri, 01 Nov 2024 10:38:02 GMT","via":"1.1 google","content-type":"text/typescript","x-jsr-cache-id":"IAD","x-goog-hash":"crc32c=vdV3Vw==,md5=czPVHZKXlEsHbjphTwziYQ==","access-control-allow-origin":"*","accept-ranges":"bytes","access-control-expose-headers":"*","etag":"\"7333d51d9297944b076e3a614f0ce261\"","content-length":"756","x-goog-stored-content-encoding":"identity","x-robots-tag":"noindex","alt-svc":"h3=\":443\"; ma=2592000,h3-29=\":443\"; ma=2592000","x-content-type-options":"nosniff","cross-origin-resource-policy":"cross-origin","age":"2934","expires":"Sat, 08 Nov 2025 09:21:07 GMT","x-guploader-uploadid":"AHmUCY2GNVHCQpB64yaSGoStmlAk88UXPEuoeuxjC6tzBD_e6DBYgDbui59rgMl2ljwhqcrZyUA","x-goog-generation":"1730457482939329","x-goog-metageneration":"1","x-goog-storage-class":"STANDARD","content-security-policy":"default-src 'none'; script-src 'none'; style-src 'none'; img-src 'none'; font-src 'none'; connect-src 'none'; frame-src 'none'; object-src 'none'; frame-ancestors 'none'; sandbox; form-action 'none';"},"url":"https://jsr.io/@std/path/1.0.8/posix/is_absolute.ts","time":1731060601}